import React, { useEffect, useState } from "react";
import InspectionAction from "../../Actions/InspectionAction";
import InspectionStore from "../../Stores/InspectionStores";
import Inspection_constants from "../../Constants/InspectionConstants";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
export default function EditInspectionRecords({
  selectedInspection,
  setSelectedInspection,
}) {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [inspectionRecord, setInspectionRecord] = useState("");

  useEffect(() => {
    if (selectedInspection) {
      setGlobalSpinner(true);
      InspectionAction.getAuftragRecord(selectedInspection);
    }
  }, [selectedInspection]);

  useEffect(() => {
    function getSelectedInspectionSuccess() {
      const res = InspectionStore.getResult();

      if (res) {
        setInspectionRecord(res.requestJson);
      } else {
        setInspectionRecord("");
      }
      setGlobalSpinner(false);
    }

    function getSelectedInspectionFailure() {
      const res = InspectionStore.getResult();

      setGlobalSpinner(false);
    }

    InspectionStore.addChangeListener(
      Inspection_constants.GET_AUFTRAG_RECORD_SUCCESS,
      getSelectedInspectionSuccess
    );
    InspectionStore.addChangeListener(
      Inspection_constants.GET_AUFTRAG_RECORD_FAILURE,
      getSelectedInspectionFailure
    );
    return () => {
      InspectionStore.removeChangeListener(
        Inspection_constants.GET_AUFTRAG_RECORD_SUCCESS,
        getSelectedInspectionSuccess
      );
      InspectionStore.removeChangeListener(
        Inspection_constants.GET_AUFTRAG_RECORD_FAILURE,
        getSelectedInspectionFailure
      );
    };
  }, []);

  function updateInspectionRecord(event) {
    event.preventDefault();
    setGlobalSpinner(true);
    InspectionAction.updateInspectionRecord({
      id: selectedInspection,
      RequestJson: inspectionRecord,
    });
  }

  function resetFields() {
    setSelectedInspection(null);
    setInspectionRecord("");
  }
  return (
    <div
      className="modal fade"
      id="editInspectionRecordModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="editInspectionRecordModal"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="editInspectionRecordModal">
              {localization.editInspectiontitle}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="editInspectionRecordModalClose"
              onClick={resetFields}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form
            className="formStyle"
            id="editRecord"
            name="editRecord"
            onSubmit={updateInspectionRecord}
          >
            <div className="modal-body">
              <div className="container">
                <div className=" row form-group">
                  <textarea
                    style={{ minHeight: "35vh" }}
                    type="text"
                    id="editInspection"
                    name="editInspection"
                    className="form-control"
                    required
                    value={inspectionRecord}
                    onChange={(e) => setInspectionRecord(e.target.value)}
                  />
                </div>
              </div>
            </div>{" "}
            <div className="modal-footer">
              <div className="form-group marProp">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                >
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
